import { put } from 'redux-saga/effects'
import axios from '../../axios-conf'
import uris from '../../uris'
import {
  accountLoadSuccess,
  accountLoadFailure,
  accountSaveSuccess,
  accountSaveFailure,
  redirect,
  addNotification,
  accountDeleteFailure,
  accountDeleteSuccess
} from '../actions'
import { uiConstants } from '../../constants'
import { uiHelper } from '../../helpers'

export function* accountLoadSaga() {
  try {
    const result = yield axios.get(uris.account)
    yield put(accountLoadSuccess(result.data))
  } catch (error) {
    yield put(addNotification(uiHelper.errorMessage(error), true))
    yield put(accountLoadFailure(uiHelper.errorMessage(error)))
  }
}

export function* accountSaveSaga(action) {
  try {
    const body = { ...action.payload }
    let url = uris.account
    let method = 'post'

    if (action.payload.id) {
      url += `/${action.payload.id}`
      method = 'put'
    }
    delete body.id
    const result = yield axios({
      method,
      url,
      data: body
    })
    yield put(accountSaveSuccess(result.data))

    if (!action.payload.id) {
      const [, id] = uiHelper.location()
      yield put(redirect(`/${id}/accounts/${result.data._id}`))
    }
    yield put(
      addNotification(
        action.payload.id
          ? uiConstants.messages.account_updated
          : uiConstants.messages.account_created
      )
    )
  } catch (error) {
    yield put(addNotification(uiHelper.errorMessage(error), true))
    yield put(accountSaveFailure(uiHelper.errorMessage(error)))
  }
}

export function* accountDeleteSaga(action) {
  try {
    yield axios.delete(`${uris.account}/${action.payload}`)
    const [, id] = uiHelper.location()
    yield put(redirect(`/${id}/accounts`))
    yield put(accountDeleteSuccess(action.payload))
    yield put(addNotification(uiConstants.messages.account_deleted))
  } catch (error) {
    yield put(addNotification(uiHelper.errorMessage(error), true))
    yield put(accountDeleteFailure(uiHelper.errorMessage(error)))
  }
}
